import React, { createContext, useCallback, useContext, useMemo, useRef } from 'react';

type OpenHandler = (row: any) => void;

type FocusViewBridgeValue = {
  registerOpenHandler: (handler: OpenHandler | null) => () => void;
  openFocusView: (row: any) => void;
};

const FocusViewBridgeContext = createContext<FocusViewBridgeValue | null>(null);

export const FocusViewBridgeProvider = ({ children }: { children: React.ReactNode }) => {
  const openHandlerRef = useRef<OpenHandler | null>(null);

  const registerOpenHandler = useCallback((handler: OpenHandler | null) => {
    openHandlerRef.current = handler;
    return () => {
      if (openHandlerRef.current === handler) {
        openHandlerRef.current = null;
      }
    };
  }, []);

  const openFocusView = useCallback((row: any) => {
    openHandlerRef.current?.(row);
  }, []);

  const value = useMemo(
    () => ({ registerOpenHandler, openFocusView }),
    [registerOpenHandler, openFocusView],
  );

  return <FocusViewBridgeContext.Provider value={value}>{children}</FocusViewBridgeContext.Provider>;
};

export const useFocusViewBridge = () => useContext(FocusViewBridgeContext);
